/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpvisibility_Title2Inputs */

const en_coinvestments_insights_lpvisibility_title2 = /** @type {(inputs: Coinvestments_Insights_Lpvisibility_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation view visibility`)
};

/**
* | output |
* | --- |
* | "Organisation view visibility" |
*
* @param {Coinvestments_Insights_Lpvisibility_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpvisibility_title2 = /** @type {((inputs?: Coinvestments_Insights_Lpvisibility_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpvisibility_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpvisibility_title2(inputs)
});
export { coinvestments_insights_lpvisibility_title2 as "coInvestments_insights_lpVisibility_title" }